import { Immutable } from "immer";
import React from "react";

import styles from "./index.module.scss";

/**
 * Renders warning message
 */
export const FormWarning = (
    props: Immutable<{
        warningTitle?: string;
        warningText?: string;
    }>,
): React.ReactNode => {
    if (!props.warningTitle || !props.warningText) {
        return null;
    }

    return (
        <div className={styles.warning} role="status">
            <p className={styles.warningCopy}>
                <strong>{props.warningTitle}</strong>
                <br />
                {props.warningText}
            </p>
        </div>
    );
};
